export default __webpack_public_path__ + "static/media/figuremap67.0bc8004a.png";